import { publicRequest } from "../../../requestMeth";
import {
  addSuggestion,
  recipientsSuccess,
  suggestionsFailure,
  suggestionsStart,
  suggestionsSuccess,
  updateSuggestion,
} from "../../reducers/suggestions/suggestionsRedux";

export const getSuggestions = async (dispatch, token, userId) => {
  dispatch(suggestionsStart());
  try {
    const res = await publicRequest.get("/suggestions", {
      headers: { token: `Bearer ${token}` },
      params: { user: userId },
    });

    dispatch(suggestionsSuccess(res.data));
    return res.data;
  } catch (error) {
    console.error("Error fetching suggestions:", error);
    dispatch(suggestionsFailure());
    throw error;
  }
};

export const getSuggestionsRecipients = async (dispatch, token, userId) => {
  dispatch(suggestionsStart());
  try {
    const res = await publicRequest.get("/suggestions/recipients", {
      headers: { token: `Bearer ${token}` },
      params: { user: userId },
    });

    dispatch(recipientsSuccess(res.data));
    return res.data;
  } catch (error) {
    console.error("Error fetching recipients:", error);
    dispatch(suggestionsFailure());
    throw error;
  }
};

export const postSuggestion = async (dispatch, token, data) => {
  dispatch(suggestionsStart());

  try {
    const res = await publicRequest.post("/suggestions", data, {
      headers: { token: `Bearer ${token}` },
    });

    if (res.data?.suggestion) {
      dispatch(
        addSuggestion({
          ...res.data.suggestion,
          messages: res.data.message ? [res.data.message] : [],
          mesagges: res.data.message ? [res.data.message] : [],
          last_message: res.data.message || null,
          unread_count: 0,
          last_read_message_id:
            res.data.message?.idmesagges || res.data.message?.id || null,
          read_at: new Date().toISOString(),
        })
      );
    } else {
      throw new Error("Respuesta inesperada del servidor");
    }

    return res.data;
  } catch (error) {
    console.error("Error en postSuggestion:", error);
    dispatch(suggestionsFailure());
    throw error;
  }
};

export const updateSuggestionRequest = async (
  dispatch,
  token,
  suggestionId,
  updatedData
) => {
  dispatch(suggestionsStart());

  try {
    const res = await publicRequest.put(
      `/suggestions/${suggestionId}`,
      updatedData,
      {
        headers: { token: `Bearer ${token}` },
      }
    );

    dispatch(updateSuggestion(res.data));
    return res.data;
  } catch (error) {
    console.error("Error updating suggestion:", error);
    dispatch(suggestionsFailure());
    throw error;
  }
};